import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const CheckCircleFilledIcon = createIcon({
    viewBox: '0 0 15 14',
    path: (
        <Path
            fill='currentColor'
            fillRule='nonzero'
            d='M6.087 10.728l6.31-6.31-1.144-1.146-5.166 5.185-2.34-2.388L2.603 7.21l3.484 3.517zM7.5 0c1.279 0 2.462.32 3.55.96a6.635 6.635 0 0 1 2.49 2.49c.64 1.088.96 2.271.96 3.55s-.32 2.462-.96 3.55a6.635 6.635 0 0 1-2.49 2.49A6.884 6.884 0 0 1 7.5 14a6.884 6.884 0 0 1-3.55-.96 6.76 6.76 0 0 1-2.49-2.506A6.854 6.854 0 0 1 .5 7c0-1.268.32-2.446.96-3.534A6.89 6.89 0 0 1 3.965.96 6.854 6.854 0 0 1 7.5 0z'
        />
    ),
})

CheckCircleFilledIcon.displayName = 'CheckCircleFilledIcon'
